import { requestWrapper } from '@/utils/axiosInstance';

const API_DEVELOPER = `${process.env.VUE_APP_API_MAIN}/developer`;

export default {
  async classes(obj) {
    return await requestWrapper(API_DEVELOPER, 'POST', '/requirements_classifiers_classes', null, obj);
  },
  async updateClasses(obj) {
    return await requestWrapper(API_DEVELOPER, 'PUT', '/requirements_classifiers_classes', null, obj);
  },
  async getClasses(id) {
    return await requestWrapper(API_DEVELOPER, 'GET', `/requirements/${id}/classifiers_classes`);
  },
};
